import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IObject } from '@type_definitions/datatypes';

type HideExpressionFn = (params?:IAgButtonDropdownRendererParams) => boolean;

interface IAgDropdownMenu {
  label:string;
  iconClass?:string;
  href?:string;
  target?:'_blank' | '_self';
  onClick: (params:IAgButtonDropdownRendererParams, index?:number) => void;
  isHidden?:boolean;
  hideExpression?:HideExpressionFn;
  translationParams?:IObject;
}

export interface IAgButtonDropdownRendererParams extends ICellRendererParams {
  dropdownMenus:IAgDropdownMenu[];
  repeatCount: (params:IAgButtonDropdownRendererParams) => number;
  wrapperClass?:string;
  hideInRowPinned?:boolean;
  dropdownContainer?:string;
}

@Component({
  selector: 'ag-button-dropdown',
  template: `
    <!-- if repeat count is not defined then just loop 1 time -->
    <ng-container *ngIf="params.hideInRowPinned ? !params.node.isRowPinned() : true">
      <div class="ag-dropdown-renderer" *ngFor="let index of repeatCount | transformNumberToCollections" [ngClass]="params.wrapperClass">
        <div class="btn-group" dropdown [container]="params.dropdownContainer || '.container'">
          <button class="btn btn-sm dropdown-arrow-btn dropdown-toggle" dropdownToggle></button>
          <ul class="dropdown-menu" *dropdownMenu>
            <ng-container *ngFor="let menu of params.dropdownMenus">
              <li *ngIf="menu.hideExpression ? !menu.hideExpression(params, index) : !menu.isHidden">
                <a [href]="menu.href" [target]="menu.target" (click)="clickHandler($event, menu, index)" translate [translateParams]="menu.translationParams"><i class="fa" [ngClass]="menu.iconClass"></i> {{menu.label}}</a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </ng-container>
  `
})
export class AgButtonDropdownRendererComponent implements ICellRendererAngularComp {
  public params!:IAgButtonDropdownRendererParams;
  public repeatCount:number;

  public agInit(params:IAgButtonDropdownRendererParams):void {
    this.params = params;
    this.setRepeatCount();
  }

  public refresh(params:IAgButtonDropdownRendererParams):boolean {
    this.params = params;
    this.setRepeatCount();
    return true;
  }
  
  public clickHandler(event:Event, menu:IAgDropdownMenu, index?:number):void {
    event.preventDefault();

    if (menu.onClick) {
      menu.onClick(this.params, index);
    }
  }

  private setRepeatCount():void {
    this.repeatCount = this.params.repeatCount ? this.params.repeatCount(this.params) : 1;
  }
}